import { render, staticRenderFns } from "./ModalBottom.vue?vue&type=template&id=4296fbf0&scoped=true"
import script from "./ModalBottom.vue?vue&type=script&lang=js"
export * from "./ModalBottom.vue?vue&type=script&lang=js"
import style0 from "./ModalBottom.vue?vue&type=style&index=0&id=4296fbf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4296fbf0",
  null
  
)

export default component.exports